import { Link } from 'react-router';

interface Props {
  link: string;
  children: JSX.Element;
  data?: any;
  classes?: any;
  testId?: string;
}

export const LinkTo = ({ link, children, data = {}, classes = {}, testId = 'link' }: Props) => {
  const params = { pathname: link };

  return (
    <Link
      to={params}
      state={data || {}}
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
      className={`flex-center-center-row-wrap ${classes}`}>
      {children}
    </Link>
  );
};
